import { render, staticRenderFns } from "./TheTopHeader.vue?vue&type=template&id=534a3fc2&"
import script from "./TheTopHeader.vue?vue&type=script&lang=ts&"
export * from "./TheTopHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports